/* Protect our Paths — open external links in a new tab.
   Any link pointing off this domain gets target="_blank" plus
   rel="noopener noreferrer". Internal links, anchors, mailto: and
   tel: links are left alone. */
(function () {
  function markExternalLinks(root) {
    var host = window.location.hostname;
    (root || document).querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      if (/^(mailto:|tel:)/i.test(href)) return;
      if (a.hasAttribute('target')) return;

      var url;
      try { url = new URL(a.href, window.location.origin); }
      catch (e) { return; }
      if (!/^https?:$/.test(url.protocol)) return;
      if (url.hostname === host) return;

      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    });
  }

  function init() { markExternalLinks(document); }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

  document.addEventListener('shopify:section:load', function (e) {
    markExternalLinks(e.target || document);
  });

  setTimeout(init, 800);
})();
